<script setup lang="ts">

import { usePresidianKickoffPresentation } from './PresidianKickoffPresentation';
import Presentation from '@presentation/Templates/Presentation.vue';

usePresidianKickoffPresentation(); 

</script>

<template>
    <Presentation />
</template>